/*
 * Public API Surface of holders
 */

export * from './pages/holders.component';
export * from './lib/holders.module';
